var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import Flex from "@irati/ui/src/Flex";
import { ImageWrapper, PerkAvatar } from "./styled";
var PopularPerks = /** @class */ (function (_super) {
    __extends(PopularPerks, _super);
    function PopularPerks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopularPerks.prototype.render = function () {
        var _a = this.props, row = _a.row, headerAccessor = _a.headerAccessor, logoUrl = _a.logoUrl;
        var perksName = get(row, headerAccessor);
        var logo = get(row, logoUrl);
        return (React.createElement(Flex, { alignItems: "center", paddingLeft: 1.5 },
            React.createElement(ImageWrapper, null,
                React.createElement(PerkAvatar, { src: logo, extraSmall: true })),
            perksName));
    };
    return PopularPerks;
}(PureComponent));
export default PopularPerks;
